module.exports = __webpack_public_path__ + "55fa948dcf2a3d95c74310ac611d53fb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/chefs-palace.png
// module id = 551
// module chunks = 0